import { Button } from "@components/ui/button";
import { useEffect, useState } from "react";
import { MdArrowBack, MdArrowForward } from "react-icons/md";
import { cn } from "@utils/index";

interface CustomCarouselProps {
  className?: string;
  items: React.ReactNode[];
  selectedIndex?: number;
  hideButtons?: boolean;
  hideProgress?: boolean;
}

function CustomCarousel(props: CustomCarouselProps) {
  const [selectedIndex, setSelectedIndex] = useState(props.selectedIndex ?? 0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    async function changePage() {
      if (props.selectedIndex === undefined) return;

      setIsTransitioning(true);
      if (isMounted) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      } else {
        setIsMounted(true);
      }
      setSelectedIndex(clamp(props.selectedIndex, 0, props.items.length - 1));

      setIsTransitioning(false);
    }

    changePage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedIndex, props.items.length]);

  function clamp(num: number, min: number, max: number) {
    return Math.min(Math.max(num, min), max);
  }

  return (
    <div
      className={
        cn(
          "flex h-full min-h-full w-full flex-1 flex-col items-center justify-center gap-2 ",
          props.className,
        )
      }
    >
      {!props.hideProgress && (
        <div className=" mt-2 w-full rounded-full bg-lightCard dark:bg-darkCard">
          <div
            className={`h-1 rounded-full bg-accentColor transition-all dark:bg-darkAccentColor`}
            style={{
              width: ((selectedIndex + 1) / props.items.length) * 100 + "%",
            }}
          ></div>
        </div>
      )}

      <div className="flex h-full min-h-full w-full flex-1 flex-row items-center justify-center">
        {!props.hideButtons && props.items.length > 1 && (
          <Button
            onClick={async () => {
              setIsTransitioning(true);

              await new Promise((resolve) => setTimeout(resolve, 100));
              if (selectedIndex > 0) {
                setSelectedIndex(selectedIndex - 1);
              } else {
                setSelectedIndex(props.items.length - 1);
              }
              setIsTransitioning(false);
            }}
          >
            <MdArrowBack />
          </Button>
        )}

        <div className="flex h-full w-full flex-1 flex-col">
          <div className={`relative h-full w-full`}>
            {props.items.map((item, index) => {
              if (selectedIndex === index && !isTransitioning) {
                return (
                  <div
                    key={`carousel_item_${index}`}
                    className="flex h-full flex-col items-center justify-center"
                  >
                    {item}
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>

        {!props.hideButtons && props.items.length > 1 && (
          <Button
            onClick={async () => {
              setIsTransitioning(true);
              await new Promise((resolve) => setTimeout(resolve, 100));
              if (selectedIndex < props.items.length - 1) {
                setSelectedIndex(selectedIndex + 1);
              } else {
                setSelectedIndex(0);
              }
              setIsTransitioning(false);
            }}
          >
            <MdArrowForward />
          </Button>
        )}
      </div>
    </div>
  );
}

export default CustomCarousel;
